import React, { useState } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import "../style.css";

const testimonials = [
  {
    text: "These Shopify sections are a game changer! I customized my store without hiring a developer.",
    name: "Amanda Brown",
    role: "Owner, Trendy Fashions",
  },
  {
    text: "The pre-built sections are so easy to use and make my store look amazing. Highly recommend!",
    name: "James Carter",
    role: "Founder, GadgetPro",
  },
];

const TestimonialSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [transition, setTransition] = useState(""); // Track the animation state

  const handlePrev = () => {
    setTransition("fade-out");
    setTimeout(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
      );
      setTransition("fade-in");
    }, 500); // Match the CSS animation duration
  };

  const handleNext = () => {
    setTransition("fade-out");
    setTimeout(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
      );
      setTransition("fade-in");
    }, 500); // Match the CSS animation duration
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <div className="testimonial-section">
      <div className="left-panel">
        <h2>
          From our <span className="highlight">community.</span>
        </h2>
        <p>
          Here’s what Shopify merchants have to say about our custom sections.
        </p>
        <div className="controls">
          <button onClick={handlePrev} className="arrow-button">
            <FaArrowLeft />
          </button>
          <button onClick={handleNext} className="arrow-button">
            <FaArrowRight />
          </button>
        </div>
      </div>

      <div className="right-panel">
        <div className={`testimonial ${transition}`}>
          <div className="testimoniall-text">
            <div className="custom-quote">“</div>
            <span className="quote">{currentTestimonial.text}”</span>
          </div>
          <div className="testimonial-text">
            <div className="profile-circle">
              {currentTestimonial.name.charAt(0)}
            </div>
            <div className="profile-cont">
              <span className="author">{currentTestimonial.name}</span>
              <span className="role">{currentTestimonial.role}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialSection;
